import { DatabaseService, Product, ProductData } from "@/core";
import { ProductRepository } from "@/core/ports/repositories/product-repository";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getProductRepository(
  databaseService: DatabaseService,
): ProductRepository {
  return getGenericRepository<Product, ProductData>(
    () => DatabaseCollection.PRODUCTS,
    databaseService,
  );
}
